import { Address } from "@/types/address";
import { joinStringsByDelimiter } from ".";

export const initAddressData: Address = {
  addressPlaceCode: null,
  street: "",
  countryCode: "",
  houseNumber: "",
  streetNumber: "",
  parcelNumber: "",
  parcelPart: "",
  evidenceNumber: "",
  city: "",
  cityPart: "",
  zip: "",
  cadastralTerritory: "",
  cadastralTerritoryCode: null,
  nameCareOf: null,
};

type AddressFormatVariant = "default" | "cadastral" | "foreign" | "czech";

// eslint-disable-next-line sonarjs/cognitive-complexity
const formatAddress = (address?: Address | null, variant: AddressFormatVariant = "default") => {
  let result = "";

  if (!address) {
    return result;
  }

  switch (variant) {
    case "cadastral": {
      result = `parc. č. `;

      if (address.parcelNumber) {
        result += address.parcelNumber;
      }
      if (address.parcelPart) {
        result += `/${address.parcelPart}`;
      }
      if (address.zip) {
        result = joinStringsByDelimiter(result, address.zip);
      }
      if (address.cadastralTerritory) {
        result += ` katastrální území `;
        result += address.cadastralTerritory;
      }

      return result;
    }

    case "default":
    case "foreign":
    case "czech":
    default:
      if (address.street) {
        result = address.street;
      }
      if (address.houseNumber) {
        result = joinStringsByDelimiter(result, address.houseNumber, "");
        if (address.streetNumber) {
          result += `/${address.streetNumber}`;
        }
      }

      if (variant !== "foreign" && address.evidenceNumber) {
        result += ` ev. ${address.evidenceNumber}`;
      }

      if (variant === "default") {
        if (address.city) {
          result = joinStringsByDelimiter(result, address.city);
        }
        if (address.zip) {
          result = joinStringsByDelimiter(result, address.zip);
        }
        return result;
      }

      if (address.zip) {
        result = joinStringsByDelimiter(result, address.zip);
      }
      if (address.city) {
        result += ` ${address.city}`;
      }
      if (variant === "foreign" && address.cityPart) {
        result += ` ${address.cityPart}`;
      }
      if (address.countryCode) {
        result += ` ${address.countryCode}`;
      }

      return result;
  }
};

export const getFormattedAddress = (address?: Address | null) => formatAddress(address);

export const getFormattedCadastralAddress = (address?: Address | null) => formatAddress(address, "cadastral");

export const getFormattedForeignAddress = (address?: Address | null) => formatAddress(address, "foreign");

export const getFormattedCzechAddress = (address?: Address | null) => formatAddress(address, "czech");
